import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthModalService } from '../../services/auth-modal.service';
import { RegisterFormComponent } from '../../components/register-form/register-form.component';

@Component({
  selector: 'eng-register-modal',
  imports: [RegisterFormComponent],
  templateUrl: './register-modal.component.html',
  styleUrl: './register-modal.component.scss',
})
export class RegisterModalComponent {
  public readonly activeModal = inject(NgbActiveModal);
  private readonly authModalService = inject(AuthModalService);

  @Input() returnUrl = '';

  openLoginModal(): void {
    this.activeModal.dismiss();
    // Use the injected auth modal service to open login modal
    setTimeout(() => {
      this.authModalService.openLoginModal(this.returnUrl);
    }, 100);
  }
}
